/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class InfraResourceTrendSummary {
    getFixupPrototypeFunction() { return InfraResourceTrendSummary.fixupPrototype; }

    static newInstance(model: Partial<InfraResourceTrendSummary>): InfraResourceTrendSummary {
        let obj = Object.assign(new InfraResourceTrendSummary(), model);
        InfraResourceTrendSummary.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<InfraResourceTrendSummary>): InfraResourceTrendSummary {
        if (!model) return null;
        return InfraResourceTrendSummary.newInstance(<InfraResourceTrendSummary> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: InfraResourceTrendSummary) {
        if (!obj) return;

        models.InfraResourceTrendSummary.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: InfraResourceTrendSummary): boolean {
        Object.setPrototypeOf(obj, InfraResourceTrendSummary.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.count === undefined) {
            this.count = 0;
        }
        if (typeof this.date === "string") {
            this.date = new Date(<string><any>this.date);
        }
    }

    /**
     * Date of the trend data point.
     */
    date: Date;

    /**
     * Resource category
     */
    category: string;

    /**
     * Change status of the infrastructure resource
     */
    change_status: models.InfraResourceChangeStatus;

    /**
     * Count of resources for the given date and category.
     */
    count: number;

}
